import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  button {
    min-width: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    background-color: #3ca2d3;
    background-image: linear-gradient(-180deg, #358ccf, #3ca2d3 90%);

    border: 0;
    border-radius: 4px;
    height: 38px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.15);
    transition: background 0.2s;

    :focus {
      border-color: #2188ff;
      box-shadow: inset 0 1px 2px rgba(27, 31, 35, 0.075),
        0 0 0 0.2em rgba(3, 102, 214, 0.3);
      transition: all 0.2s ease-in-out;
    }

    svg {
      margin-right: 8px;
    }

    &:hover {
      background: ${shade(0.15, '#3ca2d3')};
    }

    &:active {
      background-color: ${shade(0.2, '#3ca2d3')};
      box-shadow: inset 0 2px 29px 0 rgba(0, 0, 0, 0.17);
      transform: translateY(1px);
    }
  }
`;
